import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  FaCheckCircle,
  FaClock,
  FaMoneyBill,
  FaTimes
} from "react-icons/fa"

import { formatMobilePhone, moment, thousandSeparator } from "utils"
import { Button, OhOrderDetailsModal } from "components"
import PaymentFollowUpSmsModal from "./PaymentFollowUpSmsModal"
import { deliveryTypeLabels, paymentTypeLabels } from "constants"
import classes from "./OrdersTableRow.module.scss"

const OrdersTableRow = props => {
  const { order, setOrders, showPaymentFollowUp } = props

  const [t] = useTranslation()

  const [openDetailsModal, setOpenDetailsModal] = useState(false)
  const [openSmsModal, setOpenSmsModal] = useState(false)
  const paymentFollowUpSmsCount = Number(order.paymentFollowUpSmsCount || 0)

  const handlePaymentFollowUpSent = response => {
    const nextCount =
      Number(response?.paymentFollowUpSmsCount || paymentFollowUpSmsCount + 1)

    setOrders?.(orders =>
      orders.map(item =>
        item._id === order._id
          ? { ...item, paymentFollowUpSmsCount: nextCount }
          : item
      )
    )
  }

  return (
    <Fragment>
      <tr>
        <td style={{ whiteSpace: "nowrap" }}>
          <b>{order.code}</b>{" "}
          {
            !order.isViewed &&
            <span className={classes["new"]}>
              {t("جدید")}
            </span>
          }
          {
            order.source === "marketplace" &&
            <span className={classes["marketplace"]}>
              سفارش عمومی فراسود
            </span>
          }
        </td>
        <td>
          {moment(order.date).format("jYYYY/jMM/jDD")}
          <br />
          {moment(order.date).format("HH:mm")}
        </td>

        <td>
          {order.customerFullName}
          <br />
          {formatMobilePhone(order.customerMobilePhone)}
        </td>

        <td>
          {t(paymentTypeLabels[order.paymentType])}
        </td>

        <td>
          {
            order.orderStatus === "notConfirmed" &&
            <div className={classes["tag"]}>
              <FaClock />
              <div>{t("در_انتظار_تایید")}</div>
            </div>
          }
          {
            order.orderStatus === "pending" &&
            <div className={classes["tag"]}>
              <FaMoneyBill />
              <div>{t("پرداخت_نشده")}</div>
            </div>
          }
          {
            order.orderStatus === "paid" &&
            <div className={classes["tag-paid"]}>
              <FaMoneyBill />
              <div>{t("پرداخت_شده")}</div>
            </div>
          }
          {
            order.orderStatus === "delivered" &&
            <div className={classes["tag-completed"]}>
              <FaCheckCircle />
              <div>{t("تکمیل_شده")}</div>
            </div>
          }
          {
            order.orderStatus === "canceled" &&
            <div className={classes["tag-canceled"]}>
              <FaTimes />
              <div>{t("لغو_شده")}</div>
            </div>
          }
        </td>

        <td>
          {order.addedBySystem ? order.addedByFullName : t("سایت")}
        </td>

        <td>
          {t(deliveryTypeLabels[order.deliveryType])}
        </td>

        <td>
          {order.branchName}
        </td>

        <td>
          {thousandSeparator(order.totalBillAmount)}
        </td>

        <td>
          {showPaymentFollowUp && (
            <Button
              className={classes["sms-button"]}
              color="success"
              onClick={() => setOpenSmsModal(true)}
            >
              پیگیری پرداخت
              {paymentFollowUpSmsCount > 0 && (
                <span className={classes["sms-badge"]}>
                  {paymentFollowUpSmsCount.toLocaleString("fa-IR")}
                </span>
              )}
            </Button>
          )}
          <Button
            onClick={() => setOpenDetailsModal(true)}
          >
            {t("جزئیات")}
          </Button>
        </td>
      </tr>

      <OhOrderDetailsModal
        order={order}
        setOrders={setOrders}
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
      />

      <PaymentFollowUpSmsModal
        order={order}
        show={openSmsModal}
        onHide={() => setOpenSmsModal(false)}
        onSent={handlePaymentFollowUpSent}
      />
    </Fragment>
  )
}

export default OrdersTableRow
